module.exports = __webpack_public_path__ + "media/images/common/menu_coop_gifu-6ad5fe550c45e1cd7c524f0746f0a80c.png";